import { render, staticRenderFns } from "./RDW.vue?vue&type=template&id=f4246df4&scoped=true"
import script from "./RDW.vue?vue&type=script&lang=js"
export * from "./RDW.vue?vue&type=script&lang=js"
import style0 from "./RDW.vue?vue&type=style&index=0&id=f4246df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4246df4",
  null
  
)

export default component.exports